/* DDUDDI gallery pairing - 5th feedback, slide 2 (2026-08-23).

   Policy (client-confirmed): the SELECTED colour shows BOTH of its shots
   (front + side) at the top; every other colour shows one shot, in the
   product's own media order. Same rule for every product.

   How it works: media are uploaded in strict pairs per colour - odd position
   = front, even position = side. `hide_variants: true` (templates/product.json)
   keeps only the selected colour's front shot (the variant-assigned one) plus
   every unassigned side shot, and Dawn already hoists the selected media to
   the top. So all this has to do is pull that shot's pair partner up right
   behind it.

   Positions come from data-dd-pos (= media.position, emitted per <li> in
   snippets/product-media-gallery.liquid) - NOT from filenames or alt text. */
(function () {
  function ddPos(li) {
    var v = li && li.getAttribute && li.getAttribute('data-dd-pos');
    var n = v ? parseInt(v, 10) : 0;
    return n > 0 ? n : 0;
  }
  function ddGalleryPair() {
    var list = document.querySelector('.product .product__media-list');
    if (!list) return;
    var items = [].slice.call(list.children).filter(function (n) {
      return n.classList && n.classList.contains('product__media-item');
    });
    if (items.length < 2) return;

    var active = list.querySelector('.product__media-item.is-active');
    if (!active || active.parentNode !== list) active = items[0];
    var p = ddPos(active);
    if (!p) return;

    /* pairs are (1,2), (3,4), (5,6), ... */
    var partnerPos = p % 2 ? p + 1 : p - 1;
    if (partnerPos < 1) return;

    var partner = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i] !== active && ddPos(items[i]) === partnerPos) { partner = items[i]; break; }
    }
    if (!partner) return;
    if (active.nextElementSibling === partner) return;
    list.insertBefore(partner, active.nextSibling);
  }
  function ddGalSchedule() {
    [0, 120, 300, 600, 1000].forEach(function (d) { window.setTimeout(ddGalleryPair, d); });
  }
  /* 2026-08-27 중단: 선택한 컴러를 맨 위로 끓어올리는 방식을 클라이언트가
     원치 않아, 아래 initProductGallery()의 "그 사진 위치로 스크롤" 방식으로
     대체했다. 되돌리려면 ddGalSchedule() 호출만 살리면 된다. */
  void ddGalSchedule;
})();

/* NEW IN section fix: the dd-newin-sets section's drag-to-scroll calls
   setPointerCapture on pointerdown, which retargets pointerup to the scroller
   and stops the click from reaching the product/hero <a> - so cards do not
   navigate on desktop (mouse). Neutralize capture on those scrollers only:
   drag still works via scrollLeft, but clicks now reach the links. Touch is
   unaffected (the section's drag is mouse-only, so capture is never called). */
(function () {
  function neutralize() {
    var scrollers = document.querySelectorAll('[id^="DdDesk-"],[id^="DdMob-"]');
    [].forEach.call(scrollers, function (sc) {
      if (sc.__ddNoCap) return;
      sc.__ddNoCap = 1;
      sc.setPointerCapture = function () {};
    });
  }
  if (document.readyState === 'complete') neutralize();
  window.addEventListener('load', neutralize);
})();

/* ===== DDUDDI home behaviors — 6th/7th feedback + 2026-08-27 + 2026-08-31 =====
   1) Hero slideshow: stop Dawn's ~5s autoplay; advance on our own timer.
      Interval reads the section's data-speed when it is 10s or more, so once
      the slideshow schema max is raised the theme editor drives it; until then
      it stays at the 15s the client asked for in the 7th feedback.
   2) Hero slideshow: desktop mouse click-drag to change slides, matched to
      matinkim.com's own hero (Slick Carousel; distance-based drag detection
      + explicit click suppression on drag - see initSlideshow() for the
      2026-08-27 detail, including a same-day stale-flag bug fix).
   3) Brand video (bottom): force muted autoplay on load, no click.
   4) Main-page top/bottom banner images pinned to an exact 3:2 (width:height)
      box, per 2026-08-31 client feedback (한상민), item 3 — replaces the old
      2026-08-27 "min-height:38vw" rule, which had gone dead anyway (it only
      matched `:not(.banner--adapt)`, but the section is `.banner--adapt`).
      - Desktop (both hero top slide and the bottom image-banner): 3:2.
      - Mobile: hero top explicitly UNCHANGED (client said keep as-is); only
        the bottom image-banner gets 3:2.
      Cropped to fill (object-fit:cover) since Dawn's own "adapt" sizing lets
      the real image's native ratio (~2.3–2.6:1 for the current bottom photo)
      drive the box height instead of a fixed ratio. The hero slide's <img>
      is already absolute+cover via this section's own inline style further
      down, so only the container needs the ratio there; the image-banner's
      <img> isn't absolute by default, so that one needs the same treatment
      added here too.
   5) Product page: media/info column split pinned to 57/43 (2nd feedback),
      media box pinned to Matin Kim's 0.702 ratio, and the info column inset
      from the left the way Matin Kim does it (2026-08-27, both measured).
   All scoped by feature-detection so it no-ops on pages without these blocks. */
(function () {
  var FALLBACK_SLIDE_MS = 15000;

  try {
    var st = document.createElement('style');
    st.id = 'dd-home-css';
    st.textContent =
      /* hero (top): desktop-only 3:2; mobile intentionally untouched.
         Bottom image-banner's OWN 3:2 (mobile) lives in dduddi-fixes.css
         (pre-existing rule there, just retuned to 3:2) - this only adds the
         matching desktop half, since that file's image-banner block was
         mobile-only (max-width:749px) and desktop had no ratio rule at all. */
      '@media screen and (min-width:750px){' +
        '[id*="__hero"].slideshow{aspect-ratio:3/2!important;height:auto!important;min-height:0!important}' +
        '[id*="__image_banner"].banner{aspect-ratio:3/2!important;height:auto!important;min-height:0!important}' +
        '[id*="__image_banner"].banner::before,' +
        '[id*="__image_banner"] .banner__media::before{content:none!important;display:none!important}' +
        '[id*="__image_banner"] .banner__media img{' +
          'position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important}' +
      '}' +
      '.slideshow__autoplay{display:none!important}' +
      /* hero: kill native image drag so our click-drag gesture survives */
      'slideshow-component .slideshow__media img,' +
      'slideshow-component .slideshow__media picture{' +
        '-webkit-user-drag:none;user-drag:none;user-select:none;-webkit-user-select:none}' +
      /* product page: keep the media box size/ratio but show the whole product
         (contain) instead of cropping it (cover); letterbox is the transparent
         media background. 6th feedback. */
      '.product .product-media-container .product__media img{object-fit:contain!important}' +
      /* product page column split. 2nd feedback measured the stock Dawn
         'large' media size at 63/37 and asked for Matin Kim's 57/43, so pin
         it exactly rather than relying on Dawn's 55/45 'medium' preset. */
      '@media screen and (min-width:990px){' +
        '.product:not(.product--no-media) .product__media-wrapper{' +
          'max-width:57%!important;' +
          'width:calc(57% - var(--grid-desktop-horizontal-spacing) / 2)!important}' +
        '.product:not(.product--no-media) .product__info-wrapper{' +
          'max-width:43%!important;' +
          'width:calc(43% - var(--grid-desktop-horizontal-spacing) / 2)!important}' +
        /* Matin Kim insets the buy block ~85px from the info column's left edge
           and caps it around 524px, which is where the page's air comes from.
           Measured 2026-08-27 at vw1780: column 708px, buy-block 524px @ x+85. */
        '.product .product__info-container{' +
          'max-width:52rem;' +
          'margin-left:clamp(2.4rem, 8%, 8.8rem)}}' +
      /* Product media ratio, 2026-08-27 revision. Pinning every shot to 0.702
         letterboxed the portrait product photos, which the client did not
         want. Now only LANDSCAPE shots get the fixed box (so a wide frame
         doesn't collapse into a short strip); portrait and square shots keep
         their own ratio. The .dd-land class is applied by initProductGallery()
         once each image reports its natural size. */
      '@media screen and (min-width:750px){' +
        '.product .product__media-item img.dd-land{' +
          'aspect-ratio:0.702;width:100%;height:auto;object-fit:contain}}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}

  function stopDawnAutoplay(comp) {
    try { if (typeof comp.pause === 'function') comp.pause(); } catch (e) {}
    var b = comp.querySelector('.slideshow__autoplay');
    if (b && !comp.querySelector('.slideshow__autoplay--paused')) {
      try { b.click(); } catch (e) {}
    }
  }

  function slideMs(slider) {
    var s = parseInt(slider && slider.getAttribute('data-speed'), 10);
    /* the stock Dawn range caps at 9s, so anything under 10 is the default
       slider value rather than a deliberate choice - keep the 15s request */
    return s >= 10 ? s * 1000 : FALLBACK_SLIDE_MS;
  }

  function initSlideshow() {
    var comp = document.querySelector('slideshow-component');
    if (!comp || comp.__ddHome) return;
    comp.__ddHome = 1;
    var slider = comp.querySelector('[id^="Slider-"]') || comp.querySelector('.slideshow');
    var next = comp.querySelector('.slider-button--next');
    var prev = comp.querySelector('.slider-button--prev');

    /* 1) auto-advance on our own timer */
    if (next) {
      stopDawnAutoplay(comp);
      window.setTimeout(function () { stopDawnAutoplay(comp); }, 800);
      window.setInterval(function () {
        if (document.hidden) return;
        stopDawnAutoplay(comp);
        next.click();
      }, slideMs(slider));
    }

    /* 2) desktop mouse click-drag */
    if (!slider || !next || !prev) return;

    /* the browser's native image drag eats the gesture - disable it outright */
    [].forEach.call(slider.querySelectorAll('img'), function (img) {
      img.setAttribute('draggable', 'false');
    });
    slider.addEventListener('dragstart', function (e) { e.preventDefault(); });

    slider.style.cursor = 'grab';
    var down = false, dragging = false, suppressClick = false, sx = 0, sy = 0;
    /* 2026-08-27: matched to how matinkim.com's own hero actually behaves
       (Slick Carousel under the hood, confirmed live: a ~15px drag moves
       nothing and does not navigate; a plain click navigates normally).
       Slick's model is distance-based, not speed-based - any move past a
       small threshold marks the gesture as a drag and its own click handler
       explicitly swallows the click that follows; a plain click (movement
       stays under threshold) is untouched and reaches the link. A time-gated
       "flick" (tried earlier today) doesn't match this and rejects a real
       but unhurried drag, so it's replaced with the same two-threshold shape
       Slick uses: DRAG_PX marks "this was a drag at all" (-> suppress the
       click), SWIPE_PX is the larger distance needed to actually flip slides.

       Bug fixed the same day: a single shared `moved` flag, cleared only
       inside the click handler, went stale whenever a drag ended WITHOUT a
       click following it (a real drag past DRAG_PX but short of a browser-
       fired click - common; the browser simply doesn't always synthesize a
       click after real pointer movement). That left `moved` stuck true
       forever, so the very next ordinary, undragged click on the slide got
       silently swallowed too. Split into two flags instead: `dragging`
       (live, reset on every pointerdown) and `suppressClick` (set only when
       a drag really happened, and cleared on the NEXT pointerdown regardless
       of whether a click ever consumed it) - so a stale suppression can never
       survive past the start of the next gesture. */
    var DRAG_PX = 10;
    var SWIPE_PX = 45;

    function reset() {
      if (!down) return;
      down = false;
      slider.style.cursor = 'grab';
    }

    slider.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      if (e.target.closest('button, a, .slider-button, .slideshow__autoplay, .slider-counter__link')) return;
      down = true; dragging = false; suppressClick = false; sx = e.clientX; sy = e.clientY;
      slider.style.cursor = 'grabbing';
    });

    slider.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (Math.abs(e.clientX - sx) > DRAG_PX || Math.abs(e.clientY - sy) > DRAG_PX) dragging = true;
    });

    function finish(e) {
      if (!down) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      var wasDragging = dragging;
      reset();
      dragging = false;
      if (!wasDragging) return; /* stayed under the drag threshold the whole time - it was a click, leave it alone */
      suppressClick = true; /* a click MAY still follow this pointerup - swallow it if it does */
      if (Math.abs(dx) < SWIPE_PX || Math.abs(dx) < Math.abs(dy)) return;
      (dx < 0 ? next : prev).click();
    }

    /* no pointerleave reset - a fast drag can exit the slider before the
       release, and window pointerup/pointercancel already cover every exit */
    window.addEventListener('pointerup', finish);
    window.addEventListener('pointercancel', function () { reset(); dragging = false; });

    /* the actual fix: swallow the click that follows a real drag, same
       pattern as dd-newin-sets.liquid and the same thing Slick's own
       clickHandler does. Selection-drag is already blocked by user-select:
       none (dduddi-fonts.css §10), but that alone doesn't stop the ordinary
       click the browser still fires on pointerup after a drag - only this does. */
    slider.addEventListener('click', function (e) {
      if (suppressClick) { suppressClick = false; e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function initBrandVideo() {
    var dm = document.querySelector('.video-section deferred-media');
    if (!dm || dm.__ddHome) return;
    dm.__ddHome = 1;
    try { if (typeof dm.loadContent === 'function') dm.loadContent(false); } catch (e) {}
    var tries = 0;
    var timer = window.setInterval(function () {
      tries++;
      var v = dm.querySelector('video');
      if (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.loop = true;
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
        window.clearInterval(timer);
      }
      if (tries > 25) window.clearInterval(timer);
    }, 200);
  }

  window.addEventListener('load', function () {
    initSlideshow();
    initBrandVideo();
  });
})();

/* ===== 상품 상세: 갤러리 동작 (2026-08-29 개선, 2026-08-31 버그수정 x5) =====
   1) 가로 사진에만 .dd-land 를 붙여 비율을 고정한다. 세로/정방형은 원본 비율.
   2) 오른쪽 컬러칩을 누르면 그 컬러 사진을 맨 위로 끌어올리지 않고,
      원래 순서 그대로 둔 채 그 위치로 스크롤(모바일은 슬라이드)한다.

      두 가지 방식을 함께 쓴다:
      a) 관리자에서 각 변형(variant)에 대표 이미지를 직접 지정해 둔 상품은,
         Dawn이 변형 변경 시 그 사진에 자동으로 is-active를 붙인다. 그 갱신이
         끝났다는 신호(변형 변경 완료 이벤트, PUB_SUB_EVENTS.variantChange)를
         받으면 그 사진으로 스크롤한다 - alt 텍스트 추측이 필요 없고 어긋날
         일도 없다. 이게 되는 상품은 이 경로가 항상 이긴다.
      b) 변형에 이미지가 지정되지 않은 예전 상품은 사진 설명(alt: 상품명+컬러)
         으로 찾는다. alt 는 업로드 시 "상품명 + 컬러" 로 넣어두었다.

      두 경로가 같은 사진을 가리키면 scrollToItem이 중복 스크롤을 막는다.

      2026-08-31 버그수정 (1차): (a) 경로가 `typeof PUB_SUB_EVENTS !== 'undefined'`
      로 기능감지를 했는데, PUB_SUB_EVENTS는 assets/constants.js에
      `const PUB_SUB_EVENTS = {...}`로 선언되어 있다 - 최상위 const/let은
      전역(window) 프로퍼티가 되지 않으므로 이 체크는 항상 false였고, (a)
      경로 전체가 한 번도 실행되지 않았다. 실제 이벤트명 문자열('variant-change',
      constants.js 참고)을 직접 써서 고쳤다.

      2026-08-31 버그수정 (2차): 컬러를 바꾼 뒤 장바구니를 열었다 닫거나
      화면을 회전했다 되돌리면 사진이 다시 어긋나 보이는 경우가 보고됨.
      원인은 이 파일의 requestAnimationFrame 기반 "부드러운" 스크롤 애니메이션
      (22프레임) 이었다 - 그 몇백ms 동안 값을 여러 프레임에 걸쳐 조금씩
      쓰는데, 그 사이에 레이아웃이 바뀌거나(회전) 브라우저가 프레임을
      건너뛰면(드로어 열림/닫힘 트랜지션과 겹칠 때) 애니메이션이 중간에
      끊기거나 목표 위치가 이미 낡은 값이 되어, 스크롤이 목표 지점에 도달하지
      못한 채로 멈춰버릴 수 있었다. 애니메이션을 없애고 즉시 위치를
      한 번에 지정하는 방식으로 바꿔 이 실패 지점 자체를 없앴다.

      2026-08-31 버그수정 (3차): 화면을 가로로 돌리면(그리고 다시 세로로
      돌려도) 사진이 선택한 컬러와 어긋난 채로 남는다는 보고. dduddi-product.js가
      750px 지점에서 갤러리 레이아웃 자체를 바꾸는데(모바일=가로 슬라이더,
      750px+=세로 스택), 회전으로 그 경계를 넘나들면 이전 스크롤 위치가
      의미를 잃는다. resize(=orientationchange 포함)마다 활성 사진 기준으로
      다시 맞추도록 initProductGallery()에 리스너를 추가했다.

      2026-08-31 버그수정 (4차): 데스크탑 일부 상품에서 컬러칩을 눌러도
      사진이 전혀 안 바뀐다는 보고. is-active 클래스 자체는 정상적으로
      옮겨가고 있었다 - 문제는 데스크탑 경로(아래 scrollToItem의 else 분기)의
      window.scrollTo 호출이 조용히 씹히고 있었다는 것. 원인은 이 파일이 아니라
      templates/product.json의 dd_keep_media_order 블록: Dawn 자체의
      media-gallery.js가 setActiveMedia 안에서 무조건 실행하는 자체
      window.scrollTo(페이지가 엉뚱하게 맨 위/아무 위치로 튀는 원인이었다)를
      막으려고, 그 함수 호출 동안 + 이후 80ms 동안 window.scrollTo를 통째로
      no-op으로 바꿔치기해 두었었다. 그런데 이 파일의 subscribe('variant-change',
      ...) 콜백도 같은 이벤트 처리 흐름 안에서 거의 동시에 실행되므로,
      아래 데스크탑 스크롤 호출이 바로 그 80ms 무력화 구간 안에서 실행되어
      함께 씹혀버렸다 - Dawn의 원치 않는 스크롤을 막으려다 이 파일의 원하는
      스크롤까지 같이 막아버린 것. 그 80ms가 확실히 지난 뒤에 실행되도록
      데스크탑 분기만 100ms 지연시켜 충돌을 피한다 (모바일 분기는
      window.scrollTo를 안 쓰므로 애초에 영향이 없었다).

      2026-08-31 버그수정 (5차, 이후 되돌림): 데스크탑을 behavior:'instant'로
      바꿨었으나, 그 근거(smooth가 특정 상황에서 끝까지 도달 못함)는 자동화
      테스트 도구의 백그라운드 탭이라는 특수한 환경에서만 확인된 것이었고,
      실사용 환경(포그라운드 탭)에서 재현된 문제가 아니었다. 게다가 모바일의
      "2차" 수정과 이유를 섞어 설명했는데, 실제로는 서로 다른 버그였다 -
      2차는 이 파일의 자체 rAF 애니메이션이 회전/드로어 트랜지션과 겹쳐
      끊기는 문제였고, 데스크탑은 애초에 자체 애니메이션 없이 브라우저
      네이티브 smooth 스크롤(window.scrollTo behavior:'smooth')만 썼으므로
      같은 원인이 아니었다. 모바일이 CSS scroll-behavior:smooth
      (component-slider.css의 .slider--mobile) 덕분에 JS로 즉시 값을
      지정해도 여전히 부드럽게 보이는 것과 같은 이치로, 데스크탑도 굳이
      instant로 강제할 이유가 없어 smooth로 되돌린다. */
(function () {
  var HEADER_GAP = 90; /* 상단 고정 헤더에 가리지 않도록 */

  /* 15% 넘게 가로로 길 때만 "가로 사진"으로 본다. 같은 상품 안에서도 컷마다
     1920x1829 / 1920x2120 처럼 미세하게 다른 경우가 있는데, 단순히
     width > height 로 나누면 그런 컷 하나만 다른 박스에 들어가 갤러리가
     들쭉날쭉해진다. 정사각형에 가까운 컷은 원본 비율 그대로 둔다. */
  var LAND_MIN = 1.15;

  function markRatio(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    if (img.naturalWidth / img.naturalHeight >= LAND_MIN) img.classList.add('dd-land');
    else img.classList.remove('dd-land');
  }

  function selectedColor(root) {
    var groups = root.querySelectorAll('fieldset');
    for (var i = 0; i < groups.length; i++) {
      var lg = groups[i].querySelector('legend');
      var t = lg ? (lg.textContent || '') : '';
      if (!/컬러|색상|colou?r/i.test(t)) continue;
      var picked = groups[i].querySelector('input:checked');
      if (picked && picked.value) return String(picked.value).trim();
    }
    /* 드롭다운형 옵션 대비 */
    var sels = root.querySelectorAll('select');
    for (var k = 0; k < sels.length; k++) {
      var lab = sels[k].closest('.product-form__input');
      var lt = lab ? (lab.textContent || '') : '';
      if (/컬러|색상|colou?r/i.test(lt) && sels[k].value) return String(sels[k].value).trim();
    }
    return '';
  }

  /* 2026-08-31 (2차): 이전엔 requestAnimationFrame으로 22프레임에 걸쳐
     부드럽게 움직였다. 애니메이션 도중 레이아웃이 바뀌거나(화면 회전) 몇몇
     프레임이 건너뛰면(카트 드로어 열림/닫힘 트랜지션과 겹치면) 목표 지점에
     도달하지 못하고 멈출 수 있어, 컬러와 사진이 어긋난 채로 남는 문제가
     있었다. 애니메이션 없이 즉시 최종 위치로 한 번에 지정해 이 실패 지점을
     원천적으로 없앤다 - "부드럽게 슬라이드"보다 "항상 맞는 사진이 보인다"가
     우선이다. */
  function jumpScrollLeft(list, target) {
    if (Math.abs(list.scrollLeft - target) < 1) return;
    list.style.setProperty('scroll-snap-type', 'none', 'important');
    list.scrollLeft = target;
    /* re-assert on the next frame in case the browser's own snap machinery
       (or a layout pass still settling right after a resize/drawer close)
       overwrites it once more before giving control back to the user */
    window.requestAnimationFrame(function () {
      list.scrollLeft = target;
      list.style.removeProperty('scroll-snap-type');
    });
  }

  var lastHit = null; /* 두 매칭 경로가 같은 사진을 가리킬 때 중복 스크롤 방지 */

  function scrollToItem(list, hit) {
    if (!hit || hit === lastHit) return;
    lastHit = hit;

    var horizontal = list.scrollWidth > list.clientWidth + 4;
    if (horizontal) {
      /* 모바일: 갤러리가 가로 슬라이더 */
      jumpScrollLeft(list, hit.offsetLeft - list.offsetLeft);
    } else {
      /* 데스크탑: 세로로 쌓여 있으므로 페이지를 그 사진 위치로.
         2026-08-31 (4차): templates/product.json의 dd_keep_media_order가
         Dawn 자체 스크롤을 막으려고 window.scrollTo를 최대 80ms 동안
         no-op으로 바꿔치기하는 구간과 겹쳐 이 호출이 씹히지 않도록,
         그 구간이 확실히 끝난 뒤로 100ms 지연시킨다. (5차에서 잠시
         instant로 바꿨다가 되돌림 - 위 주석 참고) */
      window.setTimeout(function () {
        var top = hit.getBoundingClientRect().top + window.scrollY - HEADER_GAP;
        window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
      }, 100);
    }
  }

  /* 2026-08-31 (2차): list를 클로저에 한 번만 담아두지 않고 이벤트가 올 때마다
     다시 조회한다 - Dawn이 섹션 전체를 통째로 교체하는 경로(HTMLUpdateUtility.
     viewTransition)를 타면 예전 list는 DOM에서 떨어져 나간 죽은 참조가 되고,
     거기에 스크롤을 걸어봤자 화면엔 아무 변화가 없다. */
  function currentList() {
    var root = document.querySelector('.product');
    return root ? root.querySelector('.product__media-list') : null;
  }

  function slideToColor(colour) {
    if (!colour) return;
    var list = currentList();
    if (!list) return;
    var items = [].slice.call(list.querySelectorAll('.product__media-item'));
    var hit = null;
    for (var i = 0; i < items.length; i++) {
      var img = items[i].querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      if (alt.indexOf(colour) !== -1) { hit = items[i]; break; }
    }
    scrollToItem(list, hit);
  }

  function slideToActiveMedia() {
    var list = currentList();
    if (!list) return;
    scrollToItem(list, list.querySelector('.product__media-item.is-active'));
  }

  function initProductGallery() {
    var root = document.querySelector('.product');
    if (!root || root.__ddPg) return;
    var list = root.querySelector('.product__media-list');
    if (!list) return;
    root.__ddPg = 1;

    /* 페이지 로드 시 이미 활성화된 사진을 기준점으로 잡아둔다. 이렇게 안 하면
       첫 옵션 변경(컬러든 사이즈든) 때 사진이 실제로는 그대로인데도
       "처음 스크롤"이라는 이유만으로 강제로 그 위치까지 스크롤되어, 사용자가
       보고 있던 화면(컬러/사이즈 선택 영역)이 갑자기 위로 밀려버린다. */
    lastHit = list.querySelector('.product__media-item.is-active') || lastHit;

    [].forEach.call(list.querySelectorAll('img'), function (img) {
      if (img.complete) markRatio(img);
      else img.addEventListener('load', function () { markRatio(img); });
    });

    /* PUB_SUB_EVENTS는 assets/constants.js에 top-level const로 선언되어 있어
       window.PUB_SUB_EVENTS로는 절대 보이지 않는다 (const/let은 전역 객체에
       프로퍼티를 만들지 않음) - 그래서 `typeof PUB_SUB_EVENTS` 체크는 항상
       'undefined'였다. subscribe()는 top-level function 선언이라 실제로
       window.subscribe로 존재하므로, 이벤트명만 실제 문자열('variant-change',
       constants.js 참고)로 하드코딩하면 정상 동작한다. */
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function () {
        slideToActiveMedia();
      });
    }

    /* 대비책: 변형에 이미지가 지정되지 않은 상품은 alt 텍스트로 찾는다.
       사이즈만 바꾼 경우엔 움직이지 않는다. */
    var last = selectedColor(root);
    root.addEventListener('change', function () {
      window.setTimeout(function () {
        var now = selectedColor(root);
        if (!now || now === last) return;
        last = now;
        slideToColor(now);
      }, 60);
    });

    /* 2026-08-31 (3차): 화면을 가로로 돌리면(그리고 다시 세로로 돌려도) 사진이
       선택한 컬러와 어긋난 채로 남는다는 보고 - 정확히 "가로로 돌리는 순간"부터
       어긋난다고 함. 원인: dduddi-product.js가 750px 지점에서 갤러리 레이아웃
       자체를 바꾼다 (모바일 = 가로 스크롤 슬라이더, data-750px-이상 = 세로로
       쌓인 스택). 아이폰 상당수가 가로 모드 너비가 750px를 넘어서므로, 세로에서
       정확히 스크롤해 둔 위치(horizontal 모드의 scrollLeft)가 회전과 동시에
       레이아웃이 통째로 바뀌면서 의미를 잃는다 - 세로 모드의 페이지 스크롤
       위치는 그대로인 채 전혀 다른 사진이 뷰포트에 걸려 있게 된다. 다시 세로로
       돌아와도 scrollLeft가 그 사이 갱신된 적이 없어 어긋난 채로 남는다.
       resize(=orientationchange 포함)마다 활성 사진 기준으로 다시 맞춘다. */
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        /* hit 엘리먼트 자체는 안 바뀌었어도(컬러를 다시 고른 게 아니므로)
           레이아웃 모드가 바뀌어 스크롤 위치가 낡았을 수 있으니, 같다는
           이유로 건너뛰는 scrollToItem의 중복 방지 가드를 이번만 무시한다. */
        lastHit = null;
        slideToActiveMedia();
      }, 200);
    });
  }

  window.addEventListener('load', initProductGallery);
})();
